export function ArrowRightOutline(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM8.76765 4.10098C9.05924 3.80939 9.51993 3.78995 9.83406 4.04266L9.89902 4.10098L12.7609 6.96291C13.3064 7.5084 13.3324 8.37669 12.8389 8.95292L12.7609 9.03709L9.89902 11.899C9.5866 12.2114 9.08007 12.2114 8.76765 11.899C8.47606 11.6074 8.45662 11.1467 8.70933 10.8326L8.76765 10.7676L10.7353 8.8H3.68254C3.24071 8.8 2.88254 8.44183 2.88254 8C2.88254 7.58579 3.19734 7.2451 3.60074 7.20413L3.68254 7.2H10.7353L8.76765 5.23235C8.47606 4.94076 8.45662 4.48008 8.70933 4.16594L8.76765 4.10098Z"
          fill="#007AE7"
        />
      </svg>
    </div>
  );
}
